const safelyParseJson = (parseString: string | null): ObjectType | null => {
  if (!parseString) return null;
  try {
    return JSON.parse(parseString) as ObjectType;
  } catch (e) {
    return null;
  }
};

export default safelyParseJson;
